The date & time that the webhook attempt was acknowledged or timed out.
